import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { EmployerInterviewButton } from 'features/EmployerInterviewButton/EmployerInterviewButton';
import { useContext } from 'react';
import { useAvailabilitySlots } from 'hooks/useAvailabilitySlots';
import { useEventTypes } from 'hooks/useEventTypes';

export const ContactSidebarInvitation = () => {
  const { userProfile, userProfileMetadata } = useContext(ContactSidebarContext);

  const { eventTypes: interviewEventTypes } = useEventTypes();
  const { availabilitySlots } = useAvailabilitySlots();

  return (
    <div className="flex flex-col gap-3 bg-neutral-full-white">
      <EmployerInterviewButton
        onlyButton
        posthog={{ eventName: 'Click interview on message view [Employer ITS]' }}
        educatorId={userProfile.id}
        userProfileMetaData={userProfileMetadata}
        interviewEventTypes={interviewEventTypes}
        availabilitySlots={availabilitySlots}
      />
    </div>
  );
};

ContactSidebarInvitation.displayName = 'ContactSidebarInvitation';
